import React from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import PrimaryActionButton from './PrimaryActionButton';
import IconAction from '../IconAction';

export default function ConfirmActionDialog({
  open,
  title,
  description,
  confirmLabel = 'Conferma',
  cancelLabel = 'Annulla',
  cancelIconKey = 'actions.reset',
  cancelTone = 'default',
  tone = 'default',
  loading = false,
  onConfirm,
  onCancel,
  onOpenChange,
  focusTitle = false,
  horizontalActions = true,
  confirmFirst = false,
}) {
  const titleRef = React.useRef(null);
  const [submitting, setSubmitting] = React.useState(false);
  const busy = loading || submitting;

  React.useEffect(() => {
    if (!open) setSubmitting(false);
  }, [open]);

  function handleOpenChange(nextOpen) {
    if (busy && !nextOpen) return;
    if (!nextOpen) onCancel?.();
    onOpenChange?.(nextOpen);
  }

  async function handleConfirm() {
    if (busy) return;
    setSubmitting(true);
    try {
      await onConfirm?.();
    } finally {
      setSubmitting(false);
    }
  }

  const cancelAction = (
    <IconAction asChild iconKey={cancelIconKey} tone={cancelTone}>
      <AlertDialogCancel className="wt-confirm-dialog__cancel" disabled={busy}>
        {cancelLabel}
      </AlertDialogCancel>
    </IconAction>
  );
  const confirmAction = (
    <PrimaryActionButton
      tone={tone}
      iconKey={null}
      disabled={busy}
      onClick={handleConfirm}
      className="wt-confirm-dialog__confirm"
    >
      {busy ? 'Operazione...' : confirmLabel}
    </PrimaryActionButton>
  );

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent className="wt-confirm-dialog" onOpenAutoFocus={focusTitle ? (event) => { event.preventDefault(); titleRef.current?.focus(); } : undefined}>
        <AlertDialogHeader>
          <AlertDialogTitle ref={titleRef} tabIndex={focusTitle ? -1 : undefined}>{title}</AlertDialogTitle>
          {description ? (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          ) : null}
        </AlertDialogHeader>
        <AlertDialogFooter className={horizontalActions ? 'wt-confirm-dialog__actions--horizontal' : undefined}>
          {confirmFirst ? <>{confirmAction}{cancelAction}</> : <>{cancelAction}{confirmAction}</>}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
